exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "admin-material {\n  display: block;\n  margin-bottom: 20px;\n}\nadmin-material .icon-19 {\n  font-size: 19px;\n  height: 19px;\n  width: 19px;\n  line-height: 19px;\n  min-width: 19px;\n  min-height: 19px;\n  user-select: none;\n}\nadmin-material .width-50 {\n  width: 50px;\n}\nadmin-material .fi-table tbody tr td:first-child div {\n  cursor: zoom-in;\n}\nadmin-material .fi-table tbody tr td:last-child {\n  width: 40px;\n}", ""]);

// exports
